import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { getTemplates } from '../../server/getTemplatesCall/get-templates-call';

import { FormattedMessage } from 'react-intl';
import Button from 'react-bootstrap/Button';
import {FaImages} from 'react-icons/fa'
class ViewTemplatesPage extends Component{

  constructor(props){
    super(props);
    this.state={
      exampleTemplatesFromServer: null,
      definitionTemplatesFromServer: null,
      redirectToEdit: false
    };
    this.goToTemplate = this.goToTemplate.bind(this);
  }

  goToTemplate(id, type){
    sessionStorage.setItem("TemplateId", id);
    sessionStorage.setItem("TemplateIdType", type);
    this.setState({redirectToEdit: true});
  }

  componentDidMount(){
    getTemplates(this.props.language, "EXA").then(data => {
      this.setState({exampleTemplatesFromServer: data});
    });
    getTemplates(this.props.language, "DEF").then(data => {
      this.setState({definitionTemplatesFromServer: data});
    });
  }

  render(){
    if(this.state.redirectToEdit){
      return(
        <Redirect to="edit-template"/>
      );
    } else{
      return(
        <div className="card-alt">
          <h3><FaImages/><FormattedMessage id="vt-title"/></h3>
          <hr/>
          <h5 className='mb-4'><FormattedMessage id="vt-examples-title"/></h5>
          {this.state.exampleTemplatesFromServer ? this.state.exampleTemplatesFromServer.map((item, index) => {
            return (
              <div key={index} style={{margin: "10px"}}>
                <Button variant="link" onClick={() => this.goToTemplate(item.Id, item.Type)}>&bull;{' '}{item.Name}</Button>
              </div>
            )
          })
          :
          ""}
          <h5 className='mb-4'><FormattedMessage id="vt-definitions-title"/></h5>
          {this.state.definitionTemplatesFromServer ? this.state.definitionTemplatesFromServer.map((item, index) => {
            return (
              <div key={index} style={{margin: "10px"}}>
                <Button variant="link" onClick={() => this.goToTemplate(item.Id)}>&bull;{' '}{item.Name}</Button>
              </div>
            )
          })
          :
          ""}
        </div>
      );
    }
  }
}

export default ViewTemplatesPage;